import { Component } from '@angular/core';
import {JasoIndexComponent} from "./jaso-index.component";

@Component({
  selector: 'app-jaso-index-dialect',
  template: `
    <article class="word-navigation">
      <a *ngFor="let jaso of jasoList"
         class="word-navi-btn {{ jaso === curJasoIdx ? 'on' : '' }}"
         (click)="onClickJasoIdx($event, jaso)">{{ jaso[0] }}</a>
      <a *ngIf="mainJaso"
         class="word-navi-btn main"
         (click)="onClickJasoIdx($event, this.mainJaso)">{{ mainJaso }}</a>
    </article>
  `,
})
export class JasoIndexDialectComponent extends JasoIndexComponent {

}
